import { createAsyncThunk } from '@reduxjs/toolkit';
import quickbookApi from '~/apis/quickbook';
import {
  GET_QUICKBOOK,
  GET_QUICKBOOK_CUSTOMER,
  GET_QUICKBOOK_ITEMS,
  UPDATE_QUICKBOOK,
} from '~/utils/constants/actionType';
import { IQuickbook, IResponseGetQuickbookCustomer, IResponseGetQuickbookItem } from '~/utils/interface/quickbook';

export const handleGetQuickbook = createAsyncThunk<IQuickbook>(GET_QUICKBOOK, async (_params, { rejectWithValue }) => {
  try {
    const res = await quickbookApi.getQuickbook();
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const handleGetQuickbookCustomers = createAsyncThunk<IResponseGetQuickbookCustomer>(
  GET_QUICKBOOK_CUSTOMER,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await quickbookApi.getQuickbookCustomers();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetQuickbookItems = createAsyncThunk<IResponseGetQuickbookItem>(
  GET_QUICKBOOK_ITEMS,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await quickbookApi.getQuickbookItems();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateQuickbook = createAsyncThunk<IQuickbook, IQuickbook>(
  UPDATE_QUICKBOOK,
  async (data: IQuickbook, { rejectWithValue }) => {
    try {
      const res = await quickbookApi.updateQuickbook(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
